import client from './index';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async getPlayerItem(token: string) {
    try {
      const res = await client.get('v2/player-item/get', {
        headers: {'player-token': token},
      });
      return res.data;
    } catch (error) {
      console.log(' getPlayerItem - error ');
      return null;
    }
  },
};
